module.exports = __webpack_public_path__ + "img/imgvirsurebt.5208c2da.png";